import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appResizewindow]'
})
export class Resizewindow {
  static heightChange(): any {
    throw new Error('Method not implemented.');
  }
  windowheight:any;
  windowwidth:any;
  @Output() heightChange=new EventEmitter<any>()
  @Output() widthChange=new EventEmitter<any>()

  constructor(private _el:ElementRef,private renderer:Renderer2) { }
  ngOnInit(){
  
   this.updateHeight();

  }


  @HostListener('window:resize')
  onResize(){
    this.updateHeight()
  }
  updateHeight(){
    this.windowheight = window.innerHeight; 
    this.windowwidth = window.innerWidth;        
    this.heightChange.emit({'height':this.windowheight,"width":this.windowwidth})
     
  }

}
